<template>
  <div class="entity-detail-skeleton">
    <div class="entity-detail-skeleton__intro">
      <el-skeleton animated>
        <template slot="template">
          <div class="entity-detail-skeleton__intro-card">
            <el-skeleton-item variant="image" class="entity-detail-skeleton__gallery" />
            <div class="entity-detail-skeleton__intro-content">
              <el-skeleton-item variant="h1" class="entity-detail-skeleton__title" />
              <div class="entity-detail-skeleton__fields">
                <el-skeleton-item v-for="index in 6" :key="index" variant="text" />
              </div>
              <el-skeleton-item variant="h3" style="width: 96px; margin: 20px 0 12px" />
              <el-skeleton-item variant="text" />
              <el-skeleton-item variant="text" />
              <el-skeleton-item variant="text" style="width: 88%" />
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>

    <div class="entity-detail-skeleton__body">
      <div v-for="section in 2" :key="section" class="entity-detail-skeleton__section">
        <el-skeleton animated>
          <template slot="template">
            <el-skeleton-item variant="h3" style="width: 120px; margin-bottom: 16px" />
            <el-skeleton-item variant="image" style="width: 100%; height: 280px; border-radius: 4px" />
          </template>
        </el-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntityDetailSkeleton'
}
</script>

<style lang="scss" scoped>
.entity-detail-skeleton {
  &__intro {
    padding-top: calc(#{$header-height} + #{$spacing-2xl});
  }

  &__intro-card {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: 0 $content-padding;
    display: flex;
    gap: $spacing-2xl;
    align-items: flex-start;
  }

  &__gallery {
    width: 320px;
    height: 420px;
    flex-shrink: 0;
    border-radius: 4px;
  }

  &__intro-content {
    flex: 1;
    min-width: 0;
    padding: $spacing-xl;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba($color-brown-dark, 0.08);
  }

  &__title {
    width: 42%;
    margin-bottom: $spacing-lg;
  }

  &__fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px $spacing-xl;
    margin-bottom: $spacing-base;
  }

  &__body {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: $spacing-2xl $content-padding $spacing-4xl;
    display: flex;
    flex-direction: column;
    gap: $spacing-3xl;
  }

  &__section {
    padding: $spacing-xl;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 2px 16px rgba($color-brown-dark, 0.06);
  }
}

@media (max-width: 960px) {
  .entity-detail-skeleton {
    &__intro-card {
      flex-direction: column;
    }

    &__gallery {
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
    }

    &__fields {
      grid-template-columns: 1fr;
    }
  }
}
</style>
